import { CERT_IMG } from "@/mocks/lawfirm";

export default function CertificateCard() {
  return (
    <img
      src={CERT_IMG}
      alt="대한변호사협회 형사법 전문변호사 등록증서"
      title="형사법 전문변호사 등록증서"
      className="block h-auto w-[112px] shrink-0 rounded-md sm:w-[128px]"
    />
  );
}